import { Viewer } from '@sloyd/viewer';
import React, { useEffect, useState } from 'react';
import BrowserContainer from '../Browser/Browser.container';
import { useCopyPaste, useEditorBackground } from './Editor.hooks';
import { Center, Content, Main, Overlay, Right, Wrapper } from './Editor.style';

interface IEditorProps {
  focusMode: FocusMode;
  holodeck: IHolodeckState;
  unityVersion: UnityVersion;
  callbacks: {
    onReady: () => void;
  };
  children?: React.ReactNode;
  main?: React.ReactNode;
  right?: React.ReactNode;
}

export const Editor: React.FC<IEditorProps> = (props) => {
  const { editMode, focusMode, unityVersion, isAiRunning, holodeck, callbacks } = props;
  const [isLoaded, setIsLoaded] = useState(false);

  useCopyPaste();

  useEffect(() => {
    if (!isLoaded) return;
    callbacks.onReady();
  }, [isLoaded]);

  function renderCenter() {
    if (focusMode !== 'spawn') return;

    return (
      <Center>
        <BrowserContainer />
      </Center>
    );
  }

  const style = useEditorBackground(holodeck);

  return (
    <Wrapper $grainIntensity={holodeck.backdropGrainIntensity}>
      <Content style={style}>
        {props.children}
        <Viewer id='main' unityVersion={unityVersion} onReady={() => setIsLoaded(true)} />
        {renderCenter()}
      </Content>
      <Main>{props.main}</Main>
      <Right>{props.right}</Right>
      <Overlay />
    </Wrapper>
  );
};
